import React, { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import Header from './Header';
import DeckTile from './DeckTile';

import DECKS from '../content/content.json';
import THIEME_DECKS from '../content/thieme-content.json';
import Try from './Try';
import Footer from './Footer';
import Modal from './Modal';

function Library() {
    const VISIBLE_DECK_IDS = ['greenberg'];

    const [headerType, setHeaderType] = useState('web');    // 'web' || 'app'
    const [view, setView] = useState('library');            // 'library || 'try'
    const [selectedDeck, setSelectedDeck] = useState(null);
    const [viewingThiemeLibrary, setViewingThiemeLibrary] = useState(false);
    const [mergedDecks, setMergedDecks] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [detailsModalDeck, setDetailsModalDeck] = useState(null);

    useEffect(() => {
        locationListener();

        const MERGED_DECKS = [...THIEME_DECKS, ...DECKS];
        setMergedDecks(MERGED_DECKS);

        if (getURLParameter('theme') === 'dark') {
            document.body.classList.add('theme-dark-clean');
        } else {
            document.body.classList.remove('theme-dark-clean');
        }
    }, []);

    const isViewingLibraryThieme = () => {
        const path = window.location.pathname; // Gets the path part of the URL
        return path.endsWith('/library/thieme') || path.endsWith('/library/thieme/'); // Checks if the path ends with '/library/thieme'
    }

    const locationListener = () => {
        setViewingThiemeLibrary(isViewingLibraryThieme());

        if (getURLParameter('view') === 'app') {
            setHeaderType('app');
        } else {
            setHeaderType('web');
        }

        if (window.location.pathname.includes('try/us-capitals')) {
            setView('try');
            loadSelectedDeck('usCapitals');
        } else if (window.location.pathname.includes('try/greenberg')) {
            setView('try');
            loadSelectedDeck('greenberg');
        } else if (window.location.pathname.includes('try/plastics')) {
            setView('try');
            loadSelectedDeck('plastics');
        } else if (window.location.pathname.includes('try/topscore')) {
            setView('try');
            loadSelectedDeck('topscore');
        } else if (window.location.pathname.includes('try/gilroy-anatomy')) {
            setView('try');
            loadSelectedDeck('gilroyAnatomy');
        } else if (window.location.pathname.includes('try/step-one')) {
            setView('try');
            loadSelectedDeck('step1');
        } else {
            setView('library');
        }
    }

    const loadSelectedDeck = (deckId) => {
        const MERGED_DECKS = [...DECKS, ...THIEME_DECKS];
        setSelectedDeck(MERGED_DECKS.find(deck => deck.id === deckId) || null);
    }

    const getURLParameter = (parameterName) => {
        var url = window.location.href;
        parameterName = parameterName.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + parameterName + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    const selectDeckForDetails = (deckID) => {
        const MERGED_DECKS = [...DECKS, ...THIEME_DECKS];
        setDetailsModalDeck(MERGED_DECKS.find(deck => deck.id === deckID) || null);
        setShowDetailsModal(true);
    }

    const hideDetailsModal = () => {
        setDetailsModalDeck(null);
        setShowDetailsModal(false);
    }

    const renderDecks = () => {
        let decks;
        if (window.location.pathname.includes('thieme')) {
            decks = THIEME_DECKS.map((deck, key) => {
                if (deck.listed && VISIBLE_DECK_IDS.includes(deck.id)) {
                    return (
                        <DeckTile
                            key={key}
                            id={deck.id}
                            image={deck.image}
                            name={deck.name}
                            description={deck.description}
                            register={deck.register}
                            try={deck.try}
                            badge={deck.badge}
                            badge2={deck.badge2}
                            isThieme={deck.isThieme}
                            pro={deck.pro}
                            selectDeckForDetails={selectDeckForDetails}
                        />
                    );
                }
            })
        } else {
            decks = mergedDecks.map((deck, key) => {
                if (deck.listed && VISIBLE_DECK_IDS.includes(deck.id)) {
                    return (
                        <DeckTile
                            key={key}
                            id={deck.id}
                            image={deck.image}
                            name={deck.name}
                            description={deck.description}
                            register={deck.register}
                            try={deck.try}
                            badge={deck.badge}
                            badge2={deck.badge2}
                            isThieme={deck.isThieme}
                            pro={deck.pro}
                            selectDeckForDetails={selectDeckForDetails}
                        />
                    );
                }
            });
        }
        return decks;
    }

    const changeURLPath = (newPath) => {
        const baseURL = window.location.origin;
        const params = window.location.search;
        const newURL = baseURL + newPath;
        if (params) {
            return newURL + params;
        }
        return newURL;
    }

    return (
        <div className='app'>
            {view === 'library' &&
                <>
                    <Header
                        type={headerType}
                        thiemeLibrary={viewingThiemeLibrary}
                    />
                    <div className='layout-container'>
                        <h1>Library</h1>
                        <div className='deck-grid'>
                            {renderDecks()}
                        </div>
                    </div>
                    <Footer/>
                </>}
            {view === "try" && <Try
                deck={selectedDeck}
            />}
            {showDetailsModal && detailsModalDeck && <Modal
                name={"more-details"}
                title={detailsModalDeck.name}
                hide={hideDetailsModal}
                content={
                    <>
                        <div className='pricing'>
                            {detailsModalDeck.badge2 && <div className='option'>
                                <span className='price'>{detailsModalDeck.badge2}</span>
                                <span className='term'>/ Month</span>
                            </div>}
                            {detailsModalDeck.badge && <div className='option'>
                                <span className='price'>{detailsModalDeck.badge}</span>
                                <span className='term'>/ Year</span>
                            </div>}
                        </div>
                        {parse(detailsModalDeck.marketingCopy)}
                        <div className='actions'>
                            {detailsModalDeck.register && <a className="button" href={detailsModalDeck.register}>Unlock Now</a>}
                            {detailsModalDeck.try && <a href={changeURLPath('/try/' + detailsModalDeck.try)} className='button button--secondary'>Try</a>}
                        </div>
                    </>
                }
                hideCancel={true}
            />}
        </div>
    );
}

export default Library;
